module.exports = __webpack_public_path__ + "img/diaochahebaojia.c6b55046.jpg";